import React from 'react';
import SideMenu from '../components/SideMenu';
import UserMenu from '../components/UserMenu';
import MainContent from '../components/MainContent';
import Header from '../components/Header';

const ModifyDeedName = () => {
  return (
    <div className="flex h-screen">
    <SideMenu />
    <div className="flex-1 flex flex-col">
        <Header />
        <div className="flex flex-1">
            {/* Left Side */}
            <div className="flex-1 p-4">
            <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
            <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-4xl">
                <h2 className="text-xl font-bold mb-4">Modify Sub Deed Name</h2>
                
                <div className="flex items-center space-x-4 mb-4">
                    <label className="flex items-center">
                        <input type="radio" name="status" className="mr-2" />
                        Before Regularization
                    </label>
                    <label className="flex items-center">
                        <input type="radio" name="status" className="mr-2" />
                        After Regularization
                    </label>
                    <label className="flex items-center">
                        <input type="radio" name="status" className="mr-2" />
                        Postponed
                    </label>
                    <label className="flex items-center">
                        <input type="radio" name="status" className="mr-2" />
                        Impound
                    </label>
                    <label className="flex items-center">
                        <input type="radio" name="status" className="mr-2" />
                        Postponed/Impound
                    </label>
                    <div className="ml-auto flex space-x-2">
                        <div className="bg-gray-200 p-2 rounded-md">Book No. : 36</div>
                        <div className="bg-gray-200 p-2 rounded-md">Regno : 123</div>
                    </div>
                </div>

                <div className="flex flex-col space-y-4">
                    <div className="flex items-center">
                        <label className="w-2/5 text-gray-700">Deed</label>
                        <input type="text" className="w-full px-4 py-2 border rounded" />
                    </div>
                    <div className="flex items-center">
                        <label className="w-2/5 text-gray-700">Sub-Deed</label>
                        <input type="text" className="w-full px-4 py-2 border rounded" />
                        <input type="text" className="w-full ml-4 px-4 py-2 border rounded" placeholder="Code" />
                    </div>
                </div>

                <div className="flex justify-center mt-6">
                    <button className="bg-blue-500 text-white px-6 py-2 rounded">SAVE</button>
                </div>
            </div>
        </div>
</div>


     
        </div>
    </div>
</div>
  )
}

export default ModifyDeedName
